module.exports = __webpack_public_path__ + "static/media/facebook.a1afe99c.svg";